"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var InfoUtils = {};
InfoUtils.parse = function (info, roles) {
  var isJoined = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var parsed = {
    policy: InfoUtils.parsePolicy(info),
    moderator: InfoUtils.parseModerator(info),
    coHost: InfoUtils.parseCoHost(info)
  };
  var userDisplayHints = isJoined ? _objectSpread({}, parsed.policy) : _objectSpread({}, Object.fromEntries((0, _entries.default)(parsed.policy).filter(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
      hint = _ref2[0];
    return _constants.INTERSTITIAL_DISPLAY_HINTS.includes(hint);
  })));
  if (roles.includes(_constants.SELF_ROLES.COHOST)) {
    userDisplayHints = _objectSpread(_objectSpread({}, userDisplayHints), parsed.coHost);
  }
  if (roles.includes(_constants.SELF_ROLES.MODERATOR)) {
    userDisplayHints = _objectSpread(_objectSpread({}, userDisplayHints), parsed.moderator);
  }
  parsed.userDisplayHints = (0, _keys.default)(userDisplayHints);
  if (info.sipUri) {
    parsed.sipUri = info.sipUri;
  }
  if (info.meetingId) {
    parsed.meetingNumber = info.meetingId;
  }
  if (info.datachannelUrl) {
    parsed.datachannelUrl = info.datachannelUrl;
  }
  return parsed;
};
InfoUtils.parseDisplayHintSection = function (info, displayHintKey) {
  var displayHints = {};
  if (info && info.displayHints && info.displayHints[displayHintKey] && info.displayHints[displayHintKey].length > 0) {
    info.displayHints[displayHintKey].forEach(function (key) {
      displayHints[key] = true;
    });
  }
  return displayHints;
};
InfoUtils.parsePolicy = function (info) {
  return InfoUtils.parseDisplayHintSection(info, 'joined');
};
InfoUtils.parseModerator = function (info) {
  var displayHints = InfoUtils.parseDisplayHintSection(info, 'moderator');
  return _objectSpread(_objectSpread({}, displayHints), {}, (0, _defineProperty2.default)({}, _constants.DISPLAY_HINTS.LOWER_SOMEONE_ELSES_HAND, true));
};
InfoUtils.parseCoHost = function (info) {
  var displayHints = InfoUtils.parseDisplayHintSection(info, 'coHost');
  return _objectSpread(_objectSpread({}, displayHints), {}, (0, _defineProperty2.default)({}, _constants.DISPLAY_HINTS.LOWER_SOMEONE_ELSES_HAND, true));
};
InfoUtils.isLocked = function (policy) {
  return policy.LOCK_STATUS_LOCKED || false;
};
InfoUtils.isUnlocked = function (policy) {
  return policy.LOCK_STATUS_UNLOCKED || false;
};
InfoUtils.getInfos = function (oldInfo, newInfo, roles, isJoined) {
  var previous = null;
  if (oldInfo) {
    previous = oldInfo;
  }
  var current = newInfo && InfoUtils.parse(newInfo, roles, isJoined);
  var updates = {};
  if (current) {
    current.isLocked = InfoUtils.isLocked(current.policy);
    current.isUnlocked = InfoUtils.isUnlocked(current.policy);
    if (previous && previous.isUnlocked && current.isLocked || !previous && current.isLocked) {
      updates.isLocked = current.isLocked;
    }
    if (previous && previous.isLocked && current.isUnlocked || !previous && current.isUnlocked) {
      updates.isUnlocked = current.isUnlocked;
    }
  }
  return {
    previous: previous,
    current: current,
    updates: updates
  };
};
var _default = exports.default = InfoUtils;
//# sourceMappingURL=infoUtils.js.map
